package uk.co.nickthecoder.kyd.shapes

import uk.co.nickthecoder.kyd.util.Vector2

/**
 * [StrokeBuilder] was designed to create triangular meshes, but here we are co-opting it to produce an _outline_,
 * rather than a triangular mesh.
 *
 */
class ThickenLine : StrokeBuilder() {

    fun thicken(points: List<Vector2>): List<Vector2> {
        val worker = MyWorker()
        worker.stroke(points, false)

        val result = mutableListOf<Vector2>()
        result.addAll(worker.interiorPoints)
        result.addAll(worker.endCapPoints)
        result.addAll(worker.exteriorPoints.asReversed())
        result.addAll(worker.startCapPoints.asReversed())

        return result
    }

    /**
     * [StrokeBuilder] was designed to create triangular meshes, but here we are co-opting it to produce an _outline_,
     * rather than a triangular mesh.
     *
     * This is a little messy, because the _order_ of triangles in a mesh is not important, but the order of points
     * are. For example, the "bevel" / "fan" triangles are sent before the "main" part that leads up to it.
     * So we have to re-order using [pendingInteriorPoints] and [pendingExteriorPoints].
     */
    private inner class MyWorker : Worker() {

        val interiorPoints = mutableListOf<Vector2>()
        var exteriorPoints = mutableListOf<Vector2>()

        var pendingInteriorPoints = mutableListOf<Vector2>()
        var pendingExteriorPoints = mutableListOf<Vector2>()

        var startCapPoints = mutableListOf<Vector2>()
        var endCapPoints = mutableListOf<Vector2>()

        override fun addPair(inside: Vector2, outside: Vector2) {
            interiorPoints.add(inside)
            exteriorPoints.add(outside)

            if (pendingExteriorPoints.isNotEmpty()) {
                exteriorPoints.addAll(pendingExteriorPoints)
                pendingExteriorPoints.clear()
            }
            if (pendingInteriorPoints.isNotEmpty()) {
                interiorPoints.addAll(pendingInteriorPoints)
                pendingInteriorPoints.clear()
            }
        }

        override fun addExteriorPoint(point: Vector2, outOfSequence: Boolean) {
            if (outOfSequence) {
                pendingExteriorPoints.add(point)
            } else {
                exteriorPoints.add(point)
            }
        }

        override fun addInteriorPoint(point: Vector2, outOfSequence: Boolean) {
            if (outOfSequence) {
                pendingInteriorPoints.add(point)
            } else {
                interiorPoints.add(point)
            }
        }

        override fun addEndCapPoint(point: Vector2, isStart: Boolean) {
            if (isStart) {
                startCapPoints.add(point)
            } else {
                endCapPoints.add(point)
            }
        }

        // We aren't creating a mesh,
        override fun addMeshPoint(point: Vector2, distance: Float, isOutside: Boolean) {}
        override fun addMeshEndCapCenterPoint(point: Vector2, distance: Float) {}
        override fun addMeshEndCapFanPoint(point: Vector2, distance: Float, fanNumber: Int, fanCount: Int) {}

    }
}
